var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.from === 'pc')?[_c('index'),_c('keep-alive',{attrs:{"include":"Home"}},[_c('router-view')],1),_c('bottom')]:_vm._e(),(_vm.from === 'mobile')?[_c('router-view')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }